import 'css-chunksrc/client/pages/utilityPage/projectPage/projectStatusesList/projectStatusCreation/switch/styles.scss';export default {
  "switch": "_switch_135ns_1",
  "paragraph": "_paragraph_135ns_11",
  "iconBox": "_iconBox_135ns_18",
  "icon": "_icon_135ns_18"
};